import { useState, useEffect } from "react";
import Table from "@material-ui/core/Table";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import UserService from "../services/user-service";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import SUPopup from "../components/updateSalesPop";
import SRPopup from "../components/removeSalesPop";
import { ReactComponent as EditPic } from "../assets/editpencil.svg";
import { ReactComponent as RemovePic } from "../assets/redfilltrash.svg";
import { ReactComponent as AddImage } from "../assets/addImage.svg";
import { ReactComponent as ActionIcon } from "../assets/actionIcon.svg";
import { ReactComponent as ExportIcon } from "../assets/exportIcon.svg";
import { ReactComponent as SearchIcon } from "../assets/searchIcon.svg";
import Tooltip from "@mui/material/Tooltip";
import Popover from "@mui/material/Popover";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { Col } from "react-bootstrap";
import paginationFactory from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import moment from "moment";
import jsPDF from "jspdf";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import "jspdf-autotable";
import "../styling/table.css";
import EIPopup from "./imageHandlers/uploadExpenseReceiptDirect";

function createData(name, date, amount, fee, customer, note) {
  return { name, date, amount, fee, customer, note };
}

const rows = [
  createData(
    "Hand plane",
    "4/9/21",
    "$10.00",
    "Lowe's",
    "Workshop tools",
    "Replacement"
  ),
  createData("Oak 4 x 4 x 4", "4/21/21", "$37.00", "Lowe's", "Lumber", 0),
  createData(
    "Dado blade",
    "5/10/21",
    "$50.00",
    "Lowe's",
    "Workshop tools",
    "Drawer"
  ),
  createData("Sandpaper", "6/9/21", "$10.00", "Lowe's", "Supplies", "Bench"),
];

export default function BasicTable(props) {
  const [toLoading, setToLoading] = useState(true);
  const [nrows, setnRows] = useState(rows);
  const [showUpdate, setShowUpdate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [tempData, setTempData] = useState<any>({});
  const [fileName, setFileName] = useState("");
  const [buttonType, setButtonType] = useState("");
  const [openExportModal, setOpenExportModal] = useState(false);
  const [openImageModal, setOpenImageModal] = useState(false);
  const [reloadTableData,setReloadTableData] = useState(false)
  const [openActionModal, setOpenActionModal] =
    useState<HTMLButtonElement | null>(null);

  const handleClick = (event) => {
    setOpenActionModal(event.currentTarget);
  };

  const handleClose = () => {
    setOpenActionModal(null);
  };

  const open = Boolean(openActionModal);
  const id = open ? "simple-popover" : undefined;
  //const testkeydata = {name: 'test', amount: 100, id:'12313', site:'site', note:'', date: new Date(), category:'test'};

  function actionformat(cell, row) {
    return (
      <>
        <div className="d-flex align-items-center">
          <div>
            <ActionIcon
              aria-describedby={id}
              className="action-icon"
              onClick={(e) => {
                setTempData(row);
                handleClick(e);
              }}
            />
          </div>
          <div>
            <Tooltip
              title="Upload an image of a expense receipt or invoice"
              placement="left"
            >
              <button
                className="actionbuttonE"
                onClick={() => {
                  setTempData(row);
                  setOpenImageModal(true);
                }}
              >
                <div className="popover-btn">
                  <AddImage className="add-image" />
                </div>
              </button>
            </Tooltip>
            <Popover
              id={id}
              open={open}
              anchorEl={openActionModal}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              className="action-modal sales-action mr-3"
            >
              <div className="d-flex flex-column">
                <button
                  className="actionbuttonE"
                  onClick={() => {
                    setShowUpdate(!showUpdate);
                    setOpenActionModal(null);
                    setShowRemove(false);
                  }}
                >
                  {" "}
                  <div className="popover-btn">
                    <EditPic stroke="grey" />
                    <span className="pr-2">Update</span>
                  </div>
                </button>
                <hr className="m-0" />
                <button
                  className="actionbutton removebuttonE"
                  onClick={() => {
                    setShowUpdate(false);
                    setOpenActionModal(null);
                    setShowRemove(!showRemove);
                  }}
                >
                  <div className="popover-btn">
                    <RemovePic /> <span className="pr-1">Remove</span>
                  </div>
                </button>
              </div>
            </Popover>
          </div>
        </div>
      </>
    );
  }

  function amountformatFinalSaleCost(cell) {
    return <span> ${cell} </span>;
  }

  function amountformat(cell, row) {
    return (
      <p
        data-toggle="tooltip"
        data-placement="top"
        title={`Difference of Total Fees and Final Sales Cost is ${
          row.fee - row.amount
        }`}
      >
        ${cell}
      </p>
    );
  }

  const { SearchBar, ClearSearchButton } = Search;
  const { ExportCSVButton } = CSVExport;

  const columns = [
    {
      dataField: "name",
      text: "Item Name",
      sort: true,
      headerClasses: `column-product-name ${
        props.sideBar ? `column-header-sidebar` : `column-header`
      }`,
      classes: "column-name",
    },
    {
      dataField: "date",
      text: "Date",
      sort: true,
      sortFunc: (a, b, order) => {
        const dateA = new Date(a);
        const dateB = new Date(b);
        if (order === "asc") {
          return dateA.getTime() - dateB.getTime();
        }
        return dateB.getTime() - dateA.getTime();
      },
      headerClasses: `column-date-field ${
        props.sideBar ? `column-header-sidebar` : `column-header`
      }`,
      classes: "column-data",
      formatter: (date, row) => {
        return (
          <p
            data-toggle="tooltip"
            data-placement="top"
            title={
              row.realDate &&
              moment(row.realDate).format("hh:mm") +
                "\n" +
                moment(row.realDate).format("dddd")
            }
          >
            {date}
          </p>
        );
      },
    },
    {
      dataField: "amount",
      text: "Final Sale Cost",
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return parseFloat(a.replace(",","")) - parseFloat(b.replace(",",""));
        }
        return parseFloat(b.replace(",","")) - parseFloat(a.replace(",","")); // desc
      },
      formatter: amountformatFinalSaleCost,
      headerClasses: ` ${
        props.sideBar
          ? `column-header-sidebar column-final-cost text-center`
          : `column-header text-center`
      }`,
      classes: "column-data text-center",
    },
    {
      dataField: "fee",
      text: "Total Fees",
      sort: true,
      sortFunc: (a, b, order, dataField) => {
        if (order === "asc") {
          return parseFloat(a.replace(",","")) - parseFloat(b.replace(",",""));
        }
        return parseFloat(b.replace(",","")) - parseFloat(a.replace(",","")); // desc
      },
      formatter: amountformat,
      headerClasses: ` ${
        props.sideBar ? `column-header-sidebar` : `column-header`
      }`,
      classes: "column-data",
    },
    // {
    //   dataField: "quantity",
    //   text: "Quantity",
    //   sort: true,
    //   headerClasses: ` ${
    //     props.sideBar ? `column-header-sidebar` : `column-header`
    //   }`,
    //   classes: "column-data",
    // },
    {
      dataField: "customer",
      text: "Customer",
      sort: true,
      headerClasses: ` ${
        props.sideBar ? `column-header-sidebar` : `column-header`
      }`,
      classes: "column-data",
    },
    {
      dataField: "note",
      text: "Note",
      headerClasses: `non-sortable ${
        props.sideBar ? `column-header-sidebar column-note` : `column-header`
      }`,
      classes: "column-data",
    },
    {
      dataField: "actions",
      text: "",
      csvExport: false,
      headerClasses: `non-sortable action-column-field ${
        props.sideBar ? `column-header-sidebar` : `column-header`
      }`,
      formatter: actionformat,
      classes: "column-data",
      formatExtraData: openActionModal,
    },
  ];

  useEffect(() => {
    UserService.getSale().then((response) => {
      const filtered = UserService.getSpecificSale(
        response.data.sale,
        props.stream + 1
      );
      filtered.reverse().forEach((item) => {
        item.date = moment(item.date).format("MMM DD yyyy");
        item.amount = item.amount.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
        item.fee = item.fee.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      });
      setnRows(filtered);
      setToLoading(false);
    });
  }, [props.stream,props.reloadAPI,reloadTableData]);

  if (toLoading) {
    return (
      <TableContainer component={Paper}>
        <Table></Table>
      </TableContainer>
    );
  }

  // for pdf
  const generatePDF = (data) => {
    var doc: any = new jsPDF("l", "mm", "a4");
    const title = "Sale Report";
    const headers = [["Name", "Date", "Amount", "Fee", "Customer", "Note"]];

    const result = data.map((elt) => [
      elt.name,
      elt.date,
      elt.amount,
      elt.fee,
      elt.customer,
      elt.note,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: result,
    };

    doc.text(title, 30,40,'center');
    doc.autoTable(content);
    doc.save(fileName !== "" ? `${fileName}.pdf` : "Sales.pdf");
  };

  // console.log("tempdata",tempData)

  const renderPageList = (options) => (
    <Col className="react-bootstrap-table-pagination-list" md={6}>
      <ul className="pagination react-bootstrap-table-page-btns-ul float-right">
        {options.pages.map((page) => (
          <li
            key={page.page}
            className={`${page.active ? "active-page" : ""}page-item ${page.disabled ? "disable-page" :""}`}
            onClick={() => options.onPageChange(page.page)}
          >
            <div className="page-link">
              {page.page}
            </div>
          </li>
        ))}
      </ul>
    </Col>
  );

  const pagination = paginationFactory({
    sizePerPage: 20,
    firstPageText: "<<",
    lastPageText: ">>",
    alwaysShowAllBtns: true,
    showTotal: true,
    pageListRenderer: renderPageList,
  });

  return (
    <>
      <Popup open={openImageModal} onClose={() => setOpenImageModal(false)}>
        <div className="mode">
          <button className="close" onClick={() => setOpenImageModal(false)}>
            &times;
          </button>
          <div className="header">{tempData?.receiptImg ? "View Image":"Upload Image"}</div>
          <div className="content">
            <EIPopup keydata={tempData} closeImageModel={setOpenImageModal} setReloadTableData={setReloadTableData}/>
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={showUpdate} onClose={() => setShowUpdate(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowUpdate(false)}>
            &times;
          </button>
          <div className="header"> Update Sale </div>
          <div className="content">
            {" "}
            <SUPopup keydata={tempData} closeUpdateModel={setShowUpdate} setReloadTableData={setReloadTableData} setReloadAPI={props.setReloadAPI}></SUPopup>
            <br />
          </div>
        </div>
      </Popup>
      <Popup open={showRemove} onClose={() => setShowRemove(false)}>
        <div className="mode">
          <button className="close" onClick={() => setShowRemove(false)}>
            &times;
          </button>
          <div className="header"> Remove Sale </div>
          <div className="content">
            {" "}
            <SRPopup keydata={tempData} closeRemoveModel={setShowRemove} setReloadTableData={setReloadTableData} setReloadAPI={props.setReloadAPI}></SRPopup>
            <br />
          </div>
        </div>
      </Popup>
      <ToolkitProvider
        keyField="id"
        data={nrows}
        columns={columns}
        search
        exportCSV={{ fileName: `${fileName}.csv` }}
      >
        {(props) => (
          <div>
            <div className="py-3">
              <span className="tabletitle "> Sales </span>
              <SearchIcon id="filtersubmit" className="mr-5" />
              <SearchBar {...props.searchProps} placeholder=" " />
              <ClearSearchButton {...props.searchProps} className="btn-clear" />
              <ExportCSVButton
                className="export-button export-button-csv"
                onClick={() => {
                  setOpenExportModal(true);
                  setButtonType("CSV");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To CSV
              </ExportCSVButton>
              <button
                className="export-button btn btn-default export-button-pdf"
                onClick={() => {
                  setOpenExportModal(true);
                  setButtonType("PDF");
                  setFileName("");
                }}
              >
                <ExportIcon className="mr-2 mb-2 export-icon" />
                Export To PDF
              </button>
              <Dialog
                open={openExportModal}
                onClose={() => setOpenExportModal(false)}
                className="export-modal"
              >
                <DialogTitle className="pb-0 pt-3">
                  <p className="pb-0">
                    {buttonType === "CSV" ? "Export To CSV" : "Export To PDF"}
                  </p>
                </DialogTitle>
                <DialogContent>
                  <TextField
                    autoFocus
                    autoComplete="off"
                    value={fileName}
                    margin="dense"
                    id="name"
                    label="Enter File Name"
                    type="text"
                    fullWidth
                    variant="standard"
                    onChange={(e) => setFileName(e.target.value)}
                  />
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setOpenExportModal(false)}
                    className="export-modal-button mb-2"
                  >
                    Cancel
                  </Button>
                  {buttonType === "CSV" ? (
                    <div
                      onClick={() => setOpenExportModal(false)}
                      className="export-modal-button mb-2 ml-3"
                    >
                      <ExportCSVButton {...props.csvProps}>
                        Export CSV{" "}
                      </ExportCSVButton>
                    </div>
                  ) : (
                    <Button
                      onClick={() => {
                        generatePDF(props.baseProps.data);
                        setOpenExportModal(false);
                      }}
                      className="export-modal-button mb-2"
                    >
                      Export PDF
                    </Button>
                  )}
                </DialogActions>
              </Dialog>
            </div>
            <BootstrapTable
              {...props.baseProps}
              bordered={false}
              noDataIndication="Add Sales above"
              pagination={pagination}
            />
          </div>
        )}
      </ToolkitProvider>

      {/*
    <BootstrapTable keyField='id' data={ nrows } columns={ columns } bordered={ false }  filter={ filterFactory() } noDataIndication="Add Sale above"  />
*/}
      {/*
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHead}>Name</TableCell>
            <TableCell align="center" className={classes.tableHead}>Date</TableCell>
            <TableCell align="right" className={classes.tableHead}>Closing Price</TableCell>
            <TableCell align="right" className={classes.tableHead}>Shipping/Fee Cost</TableCell>
            <TableCell align="right" className={classes.tableHead}>Customer</TableCell>
            <TableCell align="right" className={classes.tableHead}>Note</TableCell>
            <TableCell align="right" className={classes.tableHead}>Actions</TableCell>
          </TableRow>
        </TableHead>
        */}
      {/*
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.name}>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              <TableCell align="right">{row.date}</TableCell>
              <TableCell align="right">{row.amount}</TableCell>
              <TableCell align="right">{row.fee}</TableCell>
              <TableCell align="right">{row.customer}</TableCell>
              <TableCell align="right">{row.note}</TableCell>
            </TableRow>
          ))}
        </TableBody>
        */}
      {/*
        <TableBody>
          {nrows.map((nrow) => (
            <TableRow key={nrow.name}>
              <TableCell component="th" scope="row">
                {nrow.name}
              </TableCell>
              <TableCell align="center">{nrow.date}</TableCell>
              <TableCell align="right">${nrow.amount}</TableCell>
              <TableCell align="right">{nrow.fee}</TableCell>
              <TableCell align="right">{nrow.customer}</TableCell>
              <TableCell align="right">{nrow.note}</TableCell>
              <TableCell align="right">
              <Popup
                trigger={<button className="actionbutton"> Edit </button>}
                modal
                nested
              >
              {close => (
                <div className="mode">
                  <button className="close" onClick={close}>
                    &times;
                  </button>
                  <div className="header"> Update Sale </div>
                  <div className="content">
                    {' '}
                    <EUPopup keydata={nrow} categories={props.categories}></EUPopup>
                    <br />
                  </div>
                </div>
              )}
            </Popup>
            <Popup
              trigger={<button className="actionbutton removebutton"> Remove </button>}
              modal
              nested
            >
            {close => (
              <div className="mode">
                <button className="close" onClick={close}>
                  &times;
                </button>
                <div className="header"> Remove Income Source </div>
                <div className="content">
                  {' '}
                  <ERPopup keydata={nrow} categories={props.categories}></ERPopup>
                  <br />
                </div>
              </div>
            )}
          </Popup>
          </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  */}
    </>
  );
}
